import React from "react";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/"); // Landing page route
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 50);
  };

  return (
    <header className="bg-[#F6E1A8] text-[#111827] shadow-lg">
      <div className="container mx-auto flex justify-between items-center py-4 px-6">
        {/* Logo */}
        <div onClick={goHome} className="text-2xl font-bold text-[#111827] cursor-pointer">
          BankConvert
        </div>

        {/* Centered Menu */}
        <nav className="hidden md:flex flex-1 justify-center space-x-6">
          <a href="#why" className="hover:text-[#FF4F7E] transition">
            Why BankConvert
          </a>
          <a href="#inside" className="hover:text-[#FF4F7E] transition">
            What's Inside
          </a>
          <a href="#pricing" className="hover:text-[#FF4F7E] transition">
            Pricing
          </a>
        </nav>

        {/* Get Now Button (desktop only) */}
        <a
          href="#cta"
          className="hidden md:inline-flex btn btn-sm border-2 border-black bg-[#FFE711] text-[#111827] shadow-[6px_6px_0px_0px_black]"
        >
          Start Converting
        </a>

        {/* Mobile Menu */}
        <div className="md:hidden dropdown dropdown-end">
          <label
            tabIndex={0}
            className="btn btn-ghost btn-circle text-[#111827]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </label>

          <ul
            tabIndex={0}
            className="dropdown-content menu p-3 shadow-lg bg-[#F6E1A8] text-[#111827] rounded-box w-52 mt-2 space-y-2"
          >
            <li>
              <a href="#why" className="hover:text-[#FF4F7E]">
                Why BankConvert
              </a>
            </li>
            <li>
              <a href="#inside" className="hover:text-[#FF4F7E]">
                What's Inside
              </a>
            </li>
            <li>
              <a href="#pricing" className="hover:text-[#FF4F7E]">
                Pricing
              </a>
            </li>
            <li>
              <a
                href="#cta"
                className="btn btn-sm border-none w-full bg-[#FFE711] text-[#111827]"
              >
                Start Converting
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
